import * as React from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { space, layout } from 'styled-system';

const SVG = (props) => (
  <svg
    width="80px"
    height="120px"
    viewBox="0 0 79 111"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M78.264 9.807a1.5 1.5 0 00-.457-2.071L66.43.469a1.5 1.5 0 00-1.615 2.528l8.394 5.361c-15.84 4.033-37.12 13.22-53.932 34.73C1.177 66.243-.979 95.867 1.19 109.24a1.5 1.5 0 002.961-.48c-2.066-12.74.014-41.468 17.49-63.825C37.85 24.198 58.348 15.27 73.738 11.32l-5.27 8.25a1.5 1.5 0 002.529 1.615l7.267-11.378z"
      fill="#1D1D1D"
    />
  </svg>
);

const SIZE = 110;
const CAN_SET_COLOR = true;
const SvgArrowPersona2 = styled(SVG)`
  min-height: ${SIZE}px;
  min-width: ${SIZE}px;
  max-height: ${SIZE}px;
  max-width: ${SIZE}px;
  cursor: ${(p) => (p.$pointer || p.onClick ? 'pointer' : 'default')};
  ${(p) =>
    CAN_SET_COLOR &&
    css`
      path {
        fill: ${themeGet(`colors.${p.color}`, p.color)};
      }
    `}
  ${space};
  ${layout};
`;
export default SvgArrowPersona2;
